import {v4 as uuidv4} from 'uuid';

export const sampleProducts = [
  {
    id: uuidv4(),
    manufacturer_sku: "6205-2RS1/C3",
    normalized_sku: "62052rs1c3",
    ean_gtin: "7316570000000",
    manufacturer: "SKF",
    etim_class_code: "EC000030",
    specifications: {
      inner_diameter_mm: 25.0,
      outer_diameter_mm: 52.0,
      width_mm: 15.0,
      dynamic_load_rating_n: 14000,
      static_load_rating_n: 7850,
      limiting_speed_grease_rpm: 14000,
      clearance_class: "C3",
      seal_type: "2RS",
      cage_material: "Steel",
      attributes: {
        is_stainless: false,
        has_snap_ring: false,
        contact_angle_degrees: null
      }
    },
    availability: "In Stock",
    updated_at: new Date().toISOString()
  },
  {
    id: uuidv4(),
    manufacturer_sku: "6205-2RSR-C3",
    normalized_sku: "62052rsrc3",
    ean_gtin: "4012802000000",
    manufacturer: "Schaeffler (FAG)",
    etim_class_code: "EC000030",
    specifications: {
      inner_diameter_mm: 25.0,
      outer_diameter_mm: 52.0,
      width_mm: 15.0,
      dynamic_load_rating_n: 14200,
      static_load_rating_n: 7900,
      limiting_speed_grease_rpm: 13500,
      clearance_class: "C3",
      seal_type: "2RSR",
      cage_material: "Steel",
      attributes: {
        is_stainless: false,
        has_snap_ring: false,
        contact_angle_degrees: null
      }
    },
    availability: "In Stock",
    updated_at: new Date().toISOString()
  },
  {
    id: uuidv4(),
    manufacturer_sku: "7205-B-TVP-UA",
    normalized_sku: "7205btvpua",
    ean_gtin: "7316570000001",
    manufacturer: "SKF",
    etim_class_code: "EC000031",
    specifications: {
      inner_diameter_mm: 25.0,
      outer_diameter_mm: 52.0,
      width_mm: 15.0,
      dynamic_load_rating_n: 19500,
      static_load_rating_n: 11200,
      limiting_speed_grease_rpm: 12000,
      clearance_class: "Normal",
      seal_type: "Open",
      cage_material: "Polyamide",
      attributes: {
        is_stainless: false,
        has_snap_ring: false,
        contact_angle_degrees: 40,
        is_universally_matchable: true
      }
    },
    availability: "In Stock",
    updated_at: new Date().toISOString()
  },
  {
    id: uuidv4(),
    manufacturer_sku: "HSR25A1SS",
    normalized_sku: "hsr25a1ss",
    ean_gtin: "4582213000000",
    manufacturer: "THK",
    etim_class_code: "EC000924",
    specifications: {
      size: 25,
      design: "Flanged",
      length_type: "Standard",
      accuracy_class: "N",
      preload_class: "Z0",
      load_ratings: {
        dynamic_C_N: 28000,
        static_C0_N: 46000,
        static_moments_Nm: {
          M0x: 450,
          M0y: 320,
          M0z: 320
        }
      },
      dimensions: {
        height_mm: 23,
        width_mm: 48,
        length_mm: 61.5
      },
      attributes: {
        is_stainless: true,
        has_end_seal: true,
        mounting_holes: 4
      }
    },
    availability: "In Stock",
    updated_at: new Date().toISOString()
  },
  {
    id: uuidv4(),
    manufacturer_sku: "25x47x7-NBR",
    normalized_sku: "25x47x7nbr",
    ean_gtin: "4009026000000",
    manufacturer: "Freudenberg Sealing",
    etim_class_code: "EC002306",
    specifications: {
      inner_diameter_mm: 25.0,
      outer_diameter_mm: 47.0,
      width_mm: 7.0,
      material: "NBR",
      material_shore_hardness: 75,
      temperature_range: {
        min_celsius: -40,
        max_celsius: 100
      },
      design_features: {
        has_dust_lip: true,
        outer_case: "Metal",
        helix_direction: "Right"
      },
      compatibility_matrix: {
        mineral_oils: "Excellent",
        synthetic_oils: "Good",
        water: "Excellent",
        gasoline: "Poor"
      }
    },
    availability: "In Stock",
    updated_at: new Date().toISOString()
  },
  {
    id: uuidv4(),
    manufacturer_sku: "SPA-1500-Ld",
    normalized_sku: "spa1500ld",
    ean_gtin: "4003828000000",
    manufacturer: "Optibelt",
    etim_class_code: "EC001234",
    specifications: {
      profile: "SPA",
      reference_length_ld_mm: 1500,
      calculated_lengths: {
        outer_length_la_mm: 1518,
        inner_length_li_mm: 1455
      },
      cross_section: {
        top_width_mm: 12.7,
        height_mm: 10.0,
        angle_degrees: 40
      },
      construction: {
        type: "Raw Edge Cogged",
        tensile_member: "Polyester Cord",
        cover_material: "EPDM"
      },
      performance: {
        max_power_kw: 15.5,
        min_pulley_diameter_mm: 90
      }
    },
    availability: "In Stock",
    updated_at: new Date().toISOString()
  }
];